var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOntime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.862,
    height: 15.256,
    viewBox: "0 0 17.862 15.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check2-circle",
    transform: "translate(4.12 -5.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5580",
    "data-name": "Pfad 5580",
    d: "M23.263,5.8a.618.618,0,0,1,0,.868l-8.474,8.581a.6.6,0,0,1-.857,0L10.3,11.574a.619.619,0,0,1,0-.868.6.6,0,0,1,.857,0l3.2,3.244L22.407,5.8a.6.6,0,0,1,.857,0Z",
    transform: "translate(-9.698 0.042)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5581",
    "data-name": "Pfad 5581",
    d: "M11.641,4.547A6.741,6.741,0,0,0,4.647,11a6.741,6.741,0,0,0,6.994,6.454A6.741,6.741,0,0,0,18.636,11a.638.638,0,0,1,1.272,0,7.756,7.756,0,0,1-6.126,7.366,8.567,8.567,0,0,1-9.3-3.554A7.192,7.192,0,0,1,5.8,5.607a8.791,8.791,0,0,1,9.978-1.212.566.566,0,0,1,.016,1.033.682.682,0,0,1-.652-.018A7.413,7.413,0,0,0,11.641,4.547Z",
    transform: "translate(-7.494 2.292)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntime);
export default __webpack_public_path__ + "static/media/ontime.dd9ecca7e792331642cb5505e00e4918.svg";
export { ForwardRef as ReactComponent };